import { useController } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';
import { Input, type InputProps } from './input';
import { cn } from '@talentmesh/ui/lib/utils';

export type RHFNumericInputProps = Omit<
    InputProps,
    'name' | 'value' | 'defaultValue' | 'onChange' | 'onBlur' | 'ref' | 'type'
> & {
    name: string;
};

function RHFNumericInput({ name, id, className, disabled, autoComplete = 'off', ...inputRest }: RHFNumericInputProps) {
    const { field, fieldState } = useController({ name });
    const error = fieldState.error;
    const invalid = error !== undefined;
    const inputId = id ?? name;
    const mergedClassName = cn(
        'transition-colors duration-200',
        error &&
            'border-destructive focus-visible:border-destructive focus-visible:ring-destructive dark:focus-visible:border-destructive/50 dark:focus-visible:ring-destructive/50',
        className,
    );

    return (
        <NumericFormat<InputProps>
            customInput={Input}
            getInputRef={field.ref}
            thousandSeparator
            allowNegative={false}
            id={inputId}
            name={field.name}
            value={field.value}
            onValueChange={(values) => field.onChange(values.value === '' ? undefined : values.value)}
            onBlur={field.onBlur}
            className={mergedClassName}
            aria-invalid={invalid}
            autoComplete={autoComplete}
            disabled={disabled}
            {...inputRest}
        />
    );
}

export { RHFNumericInput };
